import { CopyOutlined } from '@ant-design/icons'
import { AddressLinkType } from 'Modules'
import { useMemo } from 'react'

import { renderAddressUrl } from 'utils'
import { formatAddress } from 'utils/contract'

const LinkAddress = ({
  address,
  type = 'address',
  icon = <CopyOutlined />,
  href,
  render,
  max = 8,
  head,
  tail,
}: {
  address: string
  type?: AddressLinkType
  icon?: React.ReactNode
  href?: string
  max?: number
  /** Leading characters. Defaults to `max`. */
  head?: number
  /** Trailing characters. Defaults to `head`. */
  tail?: number
  render?: (address: string) => React.ReactNode
}) => {
  const url = useMemo(() => {
    if (!address) return '/'
    if (href) return href
    return renderAddressUrl(address, type)
  }, [address, type, href])

  const prefix = head ?? max
  const suffix = tail ?? prefix
  const sliceAddress = useMemo(() => {
    return formatAddress(address, prefix, suffix)
  }, [address, prefix, suffix])

  return address ? (
    <>
      {render ? (
        render(sliceAddress)
      ) : (
        <a target="_blank" rel="noreferrer" href={url}>
          {sliceAddress}
        </a>
      )}
    </>
  ) : null
}

export default LinkAddress
